module.exports = __webpack_public_path__ + "wafuss5.de4b36a83a6931940f59c0e7d7bbb020.png";